export const avengers = [
  {
    id: 1,
    name: 'Bruce Banner',
    username: 'Hulk',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/83.jpg?v=1602236687',
    link: 'https://marvelcinematicuniverse.fandom.com/wiki/Hulk'
  },
  {
    id: 2,
    name: 'Steve Rogers',
    username: 'Cap',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/274.jpg?v=1599853488',
    link: "https://marvelcinematicuniverse.fandom.com/wiki/Captain_America"
  },
  {
    id: 3,
    name: 'Clint Barton',
    username: 'Hawkeye',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/73.jpg?v=1597500181',
    link: "https://marvelcinematicuniverse.fandom.com/wiki/Hawkeye"
  },
  {
    id: 4,
    name: 'Natasha Romanov',
    username: 'Black Widow',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/248.jpg?v=1595053219',
    link: "https://marvelcinematicuniverse.fandom.com/wiki/Black_Widow"
  },
  {
    id: 5,
    name: 'Wanda Maximoff',
    username: 'Wanda',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/444.jpg?v=1595433035',
    link: "https://marvelcinematicuniverse.fandom.com/wiki/Scarlet_Witch"
  },
  {
    id: 6,
    name: 'Sam Wilson',
    username: 'Falcon',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/56.jpg?v=1599722900',
    link: "https://marvelcinematicuniverse.fandom.com/wiki/Falcon"
  },
  {
    id: 7,
    name: 'Bucky Barnes',
    username: 'Bucky',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/10027.jpg?v=1600577767',
    link: "https://marvelcinematicuniverse.fandom.com/wiki/Winter_Soldier"
  },
  {
    id: 8,
    name: 'Black Panther',
    username: 'Panther',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/17457.jpg?v=1584839491',
    link: "https://marvelcinematicuniverse.fandom.com/wiki/Black_Panther"
  },
  {
    id: 9,
    name: 'Thor',
    username: 'Thor',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/140.jpg?v=1594783082',
    link: "https://marvelcinematicuniverse.fandom.com/wiki/Thor"
  },
  {
    id: 10,
    name: 'Stephen Strange',
    username: 'Doc',
    icon: 'https://www.superherodb.com/pictures2/portraits/10/050/55.jpg?v=1607072096',
    link: "https://marvelcinematicuniverse.fandom.com/wiki/Doctor_Strange"
  }
];

export default avengers;